var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useActionsColors } from '../../../../../../hooks/useCurrentTheme';
var PreviewActions = function () {
    var getColor = useActionsColors();
    var actions = [
        { name: 'Fold', rI: -1 },
        { name: 'Check', rI: -1 },
        { name: 'Bet 1', rI: 0 },
        { name: 'Bet 2', rI: 1 },
        { name: 'Bet 3', rI: 2 },
        { name: 'Bet 4', rI: 3 },
        { name: 'Bet 5', rI: 4 },
        { name: 'All in', rI: -1 },
    ];
    return (_jsx("div", __assign({ style: { display: 'flex', flexWrap: 'wrap' } }, { children: actions.map(function (item, index) { return (_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', marginRight: 8 } }, { children: [_jsx("div", { style: {
                        marginRight: 8,
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        background: getColor(item.name, item.rI, index === actions.length - 1),
                    } }), _jsx("span", { children: item.name })] }), item.name)); }) })));
};
export default PreviewActions;
